import { Skeleton, Divider, Menu, Select, Row, Col, Button, message, ConfigProvider, Card } from 'antd';
import axios from 'axios';
import React, { useEffect, useState, useContext } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ArrowRightOutlined, PlusOutlined, EditOutlined } from '@ant-design/icons';
import NewsModal from './components/NewsModal';
import BlogCard from './components/BlogCard';
import TitleModal from './components/TitleModal';
import WYSIWYGModal from './components/WYSIWYGModal';
import Carousel_news_ticker from './components/Carousel_news_ticker';
import './css/cramSchool.css';
import Label_language from '../language';
// import InfiniteScroll from './components/InfiniteScroll';
import InfiniteScroll from 'react-infinite-scroll-component';
const label_language = Label_language.cramschool.children
const News = () => {
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [page, setpage] = useState(1);
    const [total, setTotal] = useState(1);
    const [itemdatacheck, setitemdatacheck] = useState(true);
    const [title, setTitle] = useState(label_language.News.children.add_news[language]);
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [open_wyswyg, set_open_wyswyg] = useState(false);
    const [title_modal, set_tiltle_modal] = useState(false);
    const [sort, setSort] = useState(JSON.stringify({ column: 'annoucement_time', type: 'descend' }));
    const [color, setColor] = useState('FF6B90');
    const [editcard, setEditCard] = useState({});
    const [content, setContent] = useState('');
    const [titleEditcard, setTitleEditCard] = useState({});
    const [messageApi, contextHolder] = message.useMessage();
    const [permission, setPermission] = useState(false);
    const get_data = () => {
        axios
            .get('/cramSchool/api/blog/lastest', { params: { "blog_type_id": 1, order: [sort], cur_page: page, size: 8 } })
            .then((response) => {
                if (page == 1) {
                    setData(response.data.data);
                    setTotal(response.data.total)
                    get_picture(response.data.data);
                } else {
                    setData(pre => { return ([...pre, ...response.data.data]) });
                    setTotal(response.data.total)
                    // console.log([...data, ...response.data.data]);
                    get_picture([...data, ...response.data.data]);
                }

            })
            .finally(() => {
                setitemdatacheck(false)
            })
    }
    const get_picture = (data_tmp) => {
        // console.log(data_tmp);
        data_tmp && data_tmp.map((value, index) => {
            let blog_id = value['blog_id']
            if (value.file_id.length != 0) {
                value.file_id.map((tmp, key) => {
                    // console.log(key, tmp);
                    // tmp['file_id']
                    axios
                        .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                        .then((response) => {
                            var blob_ = new Blob([response.data], {
                                type: "image/jpg",// this is the only MIME for SVG

                            });
                            const dataurl = URL.createObjectURL(blob_);
                            setData(
                                (pre) => {
                                    return (
                                        pre.map((value, index) => {
                                            if (blog_id == value.blog_id) {
                                                if (value.file_url != undefined) {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [...value.file_url, dataurl]
                                                        }
                                                    )
                                                } else {
                                                    return (
                                                        {
                                                            ...value,
                                                            file_url: [dataurl]
                                                        }
                                                    )
                                                }
                                            } else {
                                                return (
                                                    { ...value }
                                                )

                                            }
                                        })
                                    )
                                }
                            )

                        })
                })
            }
        })

    }
    const get_title = () => {
        axios
            .get('/cramSchool/api/blog/type', { params: { 'blog_type_id': 9 } })
            .then((response) => {
                let color_tmp = response.data.data[0].background_color.split(',');
                // console.log(color_tmp);
                setTitleEditCard(
                    (pre) => {
                        return (
                            {
                                ...pre,
                                background_color1: color_tmp[0],
                                background_color2: color_tmp[1],
                                color_show: response.data.data[0].color_show,
                            }
                        )
                    }
                )
                if (response.data.data[0].file_id.length != 0) {
                    let data_tmp = [];
                    response.data.data[0].file_id.map((tmp, i) => {
                        axios
                            .get('/cramSchool/api/file', { responseType: 'blob', params: { "file_id": tmp } })
                            .then((response) => {
                                var blob_ = new Blob([response.data], {
                                    type: "image/jpg",// this is the only MIME for SVG

                                });
                                const dataurl = URL.createObjectURL(blob_);
                                data_tmp.push({ uid: tmp, url: dataurl })
                                setTitleEditCard((pre) => {
                                    if (tmp.file_url != undefined) {
                                        return (
                                            {
                                                ...pre,
                                                file_id: [...tmp.file_id, tmp],
                                                file_url: [...tmp.file_url, dataurl]
                                            }
                                        )
                                    } else {
                                        return (
                                            {
                                                ...pre,
                                                file_id: [tmp],
                                                file_url: [dataurl]
                                            }
                                        )
                                    }
                                })
                            })
                    })
                    setTitleEditCard((pre) => {
                        return (
                            {
                                ...pre,
                                file_show: response.data.data[0].file_show,
                                // file_id: data_tmp.map((item) => item.uid),
                                // file_url: data_tmp.map((item) => item.url)
                            }
                        )
                    })
                }
            })
    }
    const get_header = () => {
        axios
            .get('/cramSchool/api/blog/header/news', { params: { "blog_type_id": 15 } })
            .then((response) => {
                setContent(response.data.data[0]);
            })
    }
    useEffect(() => {
        get_title();
        get_data();
        get_header();
        axios
            .get('/cramSchool/api/permission')
            .then((response) => {
                if (response.data.length != 0) {
                    setPermission(true);
                }
            })
    }, [])
    const handleOnEdit = (key) => {
        setTitle(label_language.News.children.edit_news[language]);
        setColor('f09a45');
        setEdit(true);
        data.map((value, index) => {
            if (index == key) {
                // console.log(value.background_color)
                setEditCard((pre) => {
                    return ({
                        ...value,
                        font_color: value.font_color == null ? '#000000' : value.font_color,
                        background_color: value.background_color == null ? '#ffef9882' : value.background_color,
                        pic_background_color: value.pic_background_color == null ? '#FFFFFF' : value.pic_background_color,
                    })
                });
            }
        })
        setOpen(true)
    }
    const handleEdit = (file_id) => {
        setOpen(false);
        // let data_tmp = [{ ...editcard }];
        if (editcard['file_id'] == "{0}") {
            editcard['file_id'] = null;
        }
        // console.log(editcard); 
        axios
            .patch(`/cramSchool/api/blog/lastest`, [{ ...editcard, file_id, "blog_type_id": 1 }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                    get_data();
                }
            })
    }
    const handleSubmit = (file_id) => {
        if (JSON.stringify(editcard) == '{}') {
            // setOpen(false);
            messageApi.open({
                type: 'error',
                content: '新增失敗，請填寫任一欄位',
            });
        } else {
            console.log(editcard['annoucement_time']);
            if (editcard['annoucement_time'] == undefined) {
                var Today = new Date();
                editcard['annoucement_time'] = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
            }
            // console.log(editcard);
            axios
                .post(`/cramSchool/api/blog/lastest`, [{ ...editcard, file_id, "blog_type_id": 1 }])
                .then((response) => {
                    if (response.data.status == 'failure') {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: label_language.Common.children.add_error[language],
                        });
                        get_data();
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: label_language.Common.children.add_success[language],
                        });
                        get_data();
                    }
                })
            // console.log(editcard); 
        }
    }
    const handleDelete = (id) => {
        const deleterow = [{ "blog_id": id }];
        axios
            .delete('/cramSchool/api/blog/lastest', {
                data: deleterow
            })
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.delete_error[language],
                    });
                    get_data();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.delete_success[language],
                    });
                    get_data();
                }
            })

    }
    useEffect(() => {
        data.forEach(each_item => {
            if (each_item.blog_id === editcard.blog_id) {
                setEditCard(prev => (
                    {
                        ...prev,
                        file_url: each_item.file_url
                    }
                ))
            }
        })
    }, [data])
    useEffect(() => {
        // console.log(sort);
        get_data();
    }, [sort])
    const handleTitleUpdate = (file_id) => {
        // console.log({ ...titleEditcard, background_color: `${titleEditcard.background_color1},${titleEditcard.background_color2}`, file_id: file_id });
        axios
            .patch('/cramSchool/api/blog/type', [{
                ...titleEditcard,
                background_color: `${titleEditcard.background_color1},${titleEditcard.background_color2}`,
                file_id: file_id,
                blog_type_id: 9
            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    set_tiltle_modal(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    set_tiltle_modal(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
                get_title();
            })
    }
    const handleUpdate = () => {
        var Today = new Date();
        let time = `${Today.getFullYear()}-${Today.getMonth() + 1}-${Today.getDate()}`;
        axios
            .patch(`/cramSchool/api/blog/header/news`, [{
                // "title": 'news_header',
                // "content": content,
                ...content,
                "blog_type_id": 15,
                "annoucement_time": time,
                // "blog_id": 218

            }])
            .then((response) => {
                if (response.data.status == 'failure') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: label_language.Common.children.edit_error[language],
                    });
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: label_language.Common.children.edit_success[language],
                    });
                }
                get_header();
                set_open_wyswyg(false);
            })
    }
    useEffect(() => {
        // console.log(page)
        get_data();
    }, [page])
    const ChangePage = () => {
        if (itemdatacheck) {
            return;
        }
        // setLoading(true);
        setitemdatacheck(false);
        setpage(pre => pre + 1)
    }
    return (
        <>
            {contextHolder}
            <WYSIWYGModal
                open={open_wyswyg}
                setOpen={set_open_wyswyg}
                data={content?.content}
                setData={setContent}
                handleUpdate={handleUpdate}
            />
            <NewsModal
                open={open}
                edit={edit}
                title={title}
                color={color}
                editcard={editcard}
                setEditCard={setEditCard}
                setOpen={setOpen}
                handleEdit={handleEdit}
                handleSubmit={handleSubmit}
                handleDelete={handleDelete}
            />
            <TitleModal
                open={title_modal}
                setOpen={set_tiltle_modal}
                title={'修改'}
                color={'f09a45'}
                edit={true}
                name={'最新消息'}
                editcard={titleEditcard}
                setEditCard={setTitleEditCard}
                handleEdit={handleTitleUpdate}
                fileShow={true}
            />
            <Row gutter={[8, 10]} justify={'end'}>
                {permission ? <>
                    <Col >
                        <Button className='example' style={{ backgroundColor: '#f09a45', color: '#FFFFFF' }} onClick={e => set_tiltle_modal(true)}>編輯標題</Button>
                    </Col>
                </> : null}
                {titleEditcard?.color_show == 1 ? <Col span={24}>
                    <Row justify={'center'} align="middle" style={{ backgroundImage: `linear-gradient(to right, ${titleEditcard.background_color1}, #ffffff,${titleEditcard.background_color2})`, padding: '10px', position: 'relative' }}>
                        <Col style={{ textAlign: 'center' }}>
                            <span style={{ fontSize: '3rem' }}>{label_language.home.children.news[language]}</span>
                        </Col>
                        {/* <Col style={{ position: 'absolute', left: '90%', top: '0%' }}>
                            <Button className='example' size='large' shape="circle" icon={<EditOutlined />} style={{ position: 'absolute', top: 0, right: 0, backgroundColor: '#F9D4E5' }} onClick={e => set_open_wyswyg(true)} />
                        </Col> */}
                    </Row>
                </Col> : null}
                {titleEditcard?.file_show == 1 ? <Col span={24}>
                    <Carousel_news_ticker
                        logo
                        height={'100%'}
                        file_url={titleEditcard?.file_url != undefined && titleEditcard?.file_url.length != 0 && titleEditcard?.file_url.map(map_item => map_item)}
                    />
                </Col> : null}
                <Col span={24}>
                    <Row gutter={[40, 16]} justify="center" align="middle" style={{ padding: '10px' }}>
                        <Col md={{ span: 6 }} sm={{ span: 24 }}>
                            <Row gutter={[8, 8]}>
                                <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                            </Row>
                        </Col>
                        <Col md={{ span: 8 }} sm={{ span: 24 }} >
                            <Row justify={'center'}>
                                <Col >
                                    <span dangerouslySetInnerHTML={{ __html: content.content }}></span>
                                </Col>
                            </Row>

                        </Col>
                        <Col md={{ span: 6 }} sm={{ span: 24 }} style={{ position: 'relative' }}>
                            <Row gutter={[8, 8]}>
                                <Col span={24} style={{ borderTop: 'solid #f5be9d 1px ' }}> </Col>
                                <Col span={24} style={{ borderTop: 'solid #f5be9d 5px ' }}> </Col>
                            </Row>
                            {permission ? <>
                                <Col className='example' style={{ position: 'absolute', top: '-350%', left: 0 }}>
                                    <EditOutlined
                                        className='example'
                                        style={{
                                            backgroundColor: '#F9D4E5',
                                            fontSize: '1.2rem',
                                            borderRadius: '50%',
                                            padding: '8px'
                                        }}
                                        onClick={e => set_open_wyswyg(true)}
                                    />
                                </Col>
                            </> : null}
                        </Col>
                    </Row>
                </Col>
                {/* <Col span={24}>
                    <Row justify={'center'} align="middle" style={{ backgroundImage: 'linear-gradient(to right, #e8cdcd, #ffffff,#8dcceb)', padding: '10px', position: 'relative' }}>
                        <Col>
                            <Col style={{ textAlign: 'center' }}>
                                <span style={{ fontSize: '3.5rem' }}>{label_language.home.children.news[language]}</span>
                            </Col>
                        </Col >
                    </Row>
                </Col> */}
                {permission ? <>
                    <Col span={24}>
                        <Row gutter={[24, 16]} style={{
                            textAlign: 'center', paddingTop: '20px', paddingBottom: '20px'
                        }} justify="end" align={'middle'}>
                            <Col>
                                <Button className='example' style={{ backgroundColor: '#FdF9C9', display: "inline-flex", alignItems: "center" }} onClick={e => { setTitle(label_language.News.children.add_news[language]); setColor('FF6B90'); setEditCard({}); setEdit(false); setOpen(true) }} icon={<PlusOutlined />}>{label_language.News.children.add_news[language]}</Button >
                            </Col>
                        </Row >
                    </Col>
                </> : null}
                <Col>
                    <Select
                        defaultValue={[label_language.Common.children.new_old[language]]}
                        style={{
                            width: 120,
                        }}
                        onChange={value => { setSort(value) }}
                        options={[
                            {
                                label: label_language.Common.children.new_old[language],
                                value: JSON.stringify({ column: 'annoucement_time', type: 'descend' }),
                            },
                            {
                                label: label_language.Common.children.old_new[language],
                                value: JSON.stringify({ column: 'annoucement_time', type: 'ascend' }),
                            },
                            // {
                            //     value: 'yiminghe',
                            //     label: '點擊次數新-舊',
                            // },
                            // {
                            //     value: 'Disabled',
                            //     label: '點擊次數舊-新',
                            // },
                        ]}
                    /></Col>
                <Col span={24}>
                    <InfiniteScroll
                        dataLength={data?.length}
                        next={ChangePage}
                        hasMore={data?.length < total}
                        loader={
                            <Skeleton
                                paragraph={{
                                    rows: 1,
                                }}
                                active
                            />
                        }
                        endMessage={<Divider plain>已經沒有貼文囉</Divider>}
                        scrollableTarget="scrollableDiv"
                    >
                        <Row gutter={[16, 16]} style={{ padding: '10px' }}>
                            <BlogCard title={true}
                                edit={permission} span={6}
                                data={data}
                                type={'straight'}
                                page={'News'}
                                handleOnEdit={handleOnEdit} />
                        </Row>
                    </InfiniteScroll>
                    {/* <InfiniteScroll
                        data={<BlogCard title={true} edit={permission} span={6} data={data} type={'straight'} page={'News'} handleOnEdit={handleOnEdit} />}
                        page={page}
                        total={total}
                        setpage={e => setpage(e)}
                        loading={itemdatacheck}
                        size={8}
                        method="window"
                    /> */}
                    {/* <Row gutter={[40, 8]} justify='center'>
                        <BlogCard title={true} edit={permission} span={6} data={data} type={'straight'} page={'News'} handleOnEdit={handleOnEdit} />
                    </Row> */}
                </Col>
                <Col span={24}>
                    <Row justify={'space-around'} style={{ padding: '20px' }}>
                        <Col className='example' style={{ cursor: 'pointer' }} onClick={e => navigate('/cramSchool/Class')}>
                            <div style={{ position: 'relative' }}>
                                <svg preserveAspectRatio="xMidYMid meet" data-bbox="23.999 20.502 152 158.998" viewBox="23.999 20.502 152 158.998" height="300" width="300" xmlns="http://www.w3.org/2000/svg" data-type="shape" role="presentation" aria-hidden="true" aria-labelledby="svgcid--q6trfg-iphlov"><title id="svgcid--q6trfg-iphlov"></title>
                                    <g >
                                        <path fill='#46A3E3' d="M33.758 60.174c-17.32 24.757-8.751 62.067 3.819 86.859 7.773 15.332 21.838 35.886 46.141 31.984 5.526-.887 10.586-3.167 16.054-4.271 16.952-3.424 36.019 4.667 51.766-1.53 6.229-2.451 11.013-6.889 14.686-11.707 11.588-15.202 12.988-35.352 3.585-51.58-6.596-11.383-18.021-20.815-22.417-32.896-4.313-11.851-1.286-24.74-4.481-36.828-3.886-14.703-20.471-25.243-37.541-16.56-6.449 3.28-11.975 7.686-19.005 10.185-7.319 2.602-15.435 3.282-22.862 5.674-13.94 4.488-23.516 11.767-29.745 20.67z"></path>
                                    </g>
                                </svg>
                            </div>
                            <div style={{ position: 'absolute', top: '35%', left: '20%', fontSize: '40px', color: '#ffffff' }}>
                                {label_language.home.children.tidbits[language] && '上課花絮'}
                            </div>
                            <div style={{ position: 'absolute', top: '55%', left: '35%', fontSize: '69px', fontWeight: 'bold', color: '#FFFFFF' }}>
                                <ArrowRightOutlined />
                            </div>
                        </Col>
                        <Col className='example' style={{ cursor: 'pointer' }} onClick={e => navigate('/cramSchool/Appointment')}>
                            <div style={{ position: 'relative' }}>
                                <svg preserveAspectRatio="none" data-bbox="31.499 20 137.001 160.001" viewBox="31.499 20 137.001 160.001" height="300" width="300" xmlns="http://www.w3.org/2000/svg" data-type="shape" role="presentation" aria-hidden="true" aria-labelledby="svgcid--wz1gan-dt201b"><title id="svgcid--wz1gan-dt201b"></title>
                                    <g>
                                        <path fill='#da9635' d="M166.344 54.704c-1.805-4.794-4.774-9.353-9.025-13.403-11.189-10.658-30.812-17.352-48.765-20.236-47.41-7.615-75.151 27.098-76.986 56.126-.874 13.824 6.889 27.31 7.497 41.175.652 14.878-5.574 29.557-2.586 44.536 1.666 8.348 8.576 13.214 20.06 15.16 34.353 5.821 80.34-1.147 97.585-25.256 4.83-6.752 6.951-14.461 7.698-21.959.881-8.85-1.181-17.654-1.463-26.49-.268-8.412 2.606-16.449 5.664-24.509 3.091-8.151 3.392-16.986.321-25.144z"></path>
                                    </g>
                                </svg>
                                <div style={{ position: 'absolute', top: '35%', left: '20%', fontSize: '40px', color: '#FFFFFF' }}>
                                    {label_language.home.children.appointment[language] && '填單預約'}
                                </div>
                                <div style={{ position: 'absolute', top: '55%', left: '35%', fontSize: '69px', fontWeight: 'bold', color: '#ffffff' }}>
                                    <ArrowRightOutlined />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>

        </>
    )
}
export default News;